
let language = {
    SET_AS_SHARE_FILE_SHARE_ROOT_TITLE: "设置为共享根文件夹",
    SET_AS_SHARE_FILE_WHETHER_MIGRATE: "是否将数据从旧文件夹迁移至新文件夹？",
    SET_AS_SHARE_FILE_NEED_MIGRATE: "需要迁移",
    
    // 
    SET_AS_SHARE_FILE_CANCEL_BTN: "取消",
    SET_AS_SHARE_FILE_OK_BTN: "确认",
};

export { language }